import React from 'react';
import { Link } from "react-router-dom";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faBars, faTimes} from '@fortawesome/pro-light-svg-icons';

const MobileNavBar = ({mobileLogo, toggleMenu, menuCollapsed, sitePrefix}) => (
    <nav className="navbar navbar-dark navbar-expand-lg d-lg-none fixed-top row">
        <Link className="navbar-brand logo-mobile col-6" to={sitePrefix}>
            <img className="logo-mobile-img d-inline-block align-top mx-auto"
                 src={mobileLogo}/>
        </Link>
        <span onClick={toggleMenu} className="navbar-toggler col-4 text-right "
              data-toggle="collapse"
              data-target=".menu"
              aria-controls="menu"
              aria-expanded="true"
              aria-label="Toggle navigation">
                        MENU {' '} {menuCollapsed ? <FontAwesomeIcon icon={faTimes}/> : <FontAwesomeIcon icon={faBars}/>}
                    </span>
    </nav>
);

export default MobileNavBar;
